/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@express-labs/raven-ui';
import { cn } from '@express-labs/raven-tools';
import s from './SearchInput.module.scss';

function SearchInput({
  className, id, name, placeholder, value, onChange, onKeyUp, url,
}) {
  return (
    <div className={cn(s.container, className, 'container-search')} aria-label="search-input">
      <Icon icon="searchIcon" />
      <form
        className={cn(s.searchForm, 'search-form')}
        action={url}
        method="get"
        autoComplete="off"
        /* eslint-disable-next-line react/no-unknown-property */
        unbxdattr="sq_bt"
        id="unbxd-search"
      >
        <input
          id={id}
          name={name}
          type="search"
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onKeyUp={onKeyUp}
          className={cn('search-field', s.input)}
          /* eslint-disable-next-line react/no-unknown-property */
          unbxattr="sq"
          aria-label="Product Search. Press enter to run search."
        />
      </form>
    </div>
  );
}

SearchInput.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  onKeyUp: PropTypes.func,
  placeholder: PropTypes.string,
  url: PropTypes.string.isRequired,
  value: PropTypes.string,
};

export default SearchInput;
